import Vue from 'vue'
import AppTabs from './AppTabs'
import AppTab from './AppTab'

Vue.component(AppTabs.name, AppTabs)
Vue.component(AppTab.name, AppTab)
